import React from 'react';

const PageTitleServices = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large text-uppercase">Tjänster</h1>
            </div>
        </div>
    );
};

export default PageTitleServices;
